(function () {
	var loaded = false;

	function loadDeferred() {
		if (loaded) return;
		loaded = true;

		document.querySelectorAll('script[data-src]').forEach(function (s) {
			s.setAttribute('src', s.getAttribute('data-src'));
			s.removeAttribute('data-src');
		});
		document.querySelectorAll('link[data-href]').forEach(function (l) {
			l.setAttribute('href', l.getAttribute('data-href'));
			l.removeAttribute('data-href');
		});

		setTimeout(function () {
			document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
			document.dispatchEvent(new CustomEvent('StartKernelLoading'));
		}, 400);
	}

	['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'].forEach(function (e) {
		window.addEventListener(e, loadDeferred, { once: true, passive: true });
	});

	window.addEventListener('load', function () {
		setTimeout(loadDeferred, 3000);
	});
})();